export const TRANSLATIONS_FR_SETTINGS_GOOGLE = {
  "settings.google.connection_status_title": "État de la connexion",
  "settings.google.loading_status": "Chargement de l'état...",
  "settings.google.connected": "Connecté",
  "settings.google.connect_button": "Se connecter avec Google",
  "settings.google.no_accounts": "Aucun compte connecté.",
  "settings.google.gmail_messages_title": "Messages Gmail",
  "settings.google.no_messages": "Aucun message à afficher.",
  "settings.google.drive_files_title": "Fichiers Drive",
  "settings.google.root": "(Racine)",
  "settings.google.no_files": "Aucun fichier à afficher.",
  "settings.google.diagnostics_title": "Diagnostics et tests",
  "settings.google.audit_title": "Audit et sécurité",
  "settings.google.manage_access_link": "Gérer l'accès dans mon compte Google",
  "settings.google.privacy_policy": "Politique de confidentialité",
  "settings.google.terms_of_service": "Conditions d'utilisation",
  "settings.google.multi_account_title": "Gestion multi‑compte",
  "settings.google.reauthorize": "Réautoriser",
  "settings.google.revoke": "Révoquer",
  "settings.google.make_default": "Définir par défaut",
  "settings.google.oauth_processing": "Traitement de l'authentification Google...",
  "settings.google.table.subject": "Objet",
  "settings.google.table.from": "De",
  "settings.google.table.received_at": "Reçu",
  "settings.google.table.body_preview": "Aperçu",
  "settings.google.table.has_attachments": "Pièces jointes",
  "settings.google.table.name": "Nom",
  "settings.google.table.type": "Type",
  "settings.google.table.size": "Taille",
  "settings.google.table.modified": "Modifié",
  "settings.google.table.created_by": "Créé par",
  "settings.google.table.status": "Statut",
  "settings.google.table.time": "Heure",
  "settings.google.table.message": "Message",
  "settings.google.table.account": "Compte",
  "settings.google.table.scopes": "Périmètres",
  "settings.google.table.default": "Par défaut",
  "settings.google.table.actions": "Actions",
  "settings.google.table.sync_period": "Synchroniser depuis",
  "settings.google.save_sync_start_date": "Enregistrer la date",
  "settings.google.sync_process_title": "Synchronisation du compte",
  "settings.google.sync.mail_sync_status": "Statut synchronisation courrier",
  "settings.google.sync.drive_sync_status": "Statut synchronisation drive",
  "settings.google.sync.last_read_email_date": "Date du dernier e-mail synchronisé",
  "settings.google.sync.last_sync_date": "Dernière synchronisation",
  "settings.google.sync.emails_processed": "E-mails traités",
  "settings.google.sync.period": "Période de synchronisation",
  "settings.google.sync.period_updated_prefix": "Date de debut de synchronisation mise a jour vers",
  "settings.google.sync.resync_requested": "Resynchronisation demandee.",
  "settings.google.sync.set_period": "Définir la période",
  "settings.google.sync.all": "Tous",
  "settings.google.sync.not_set": "Non défini",
};
